module.exports = __webpack_public_path__ + "img/excel-file.a9860488.svg";